import { Action, handleActions } from 'redux-actions'
import { GetAnnouncementFilters$Response, NotificationDto } from '../../../services/api.types'
import {
  createAnnouncementFail,
  createAnnouncementSuccess,
  deleteAnnouncementsFail,
  deleteAnnouncementsSuccess,
  editAnnouncementFail,
  editAnnouncementSuccess,
  getAnnouncementFiltersSuccess,
  getAnnouncements,
  getAnnouncementsFail,
  getAnnouncementsSuccess,
} from './AnnouncementsActions'

class State {
  list: NotificationDto[] = []
  isLoading: boolean = false
  lastUpdate: number | null = null
  filters: GetAnnouncementFilters$Response = {
    announcementLimitExceeded: false,
    totalUserCount: 0,
    pushEnabledUserCount: 0,
    emailEnabledUserCount: 0,
    challenges: [],
    teams: [],
    countries: [],
    languages: [],
  }
}

export const announcements = handleActions<State, any>(
  {
    [String(getAnnouncements)]: (state: State): State => ({
      ...state,
      isLoading: true,
    }),
    [String(getAnnouncementsSuccess)]: (state: State, action: Action<NotificationDto[]>): State => ({
      ...state,
      list: action.payload,
      isLoading: false,
    }),
    [String(getAnnouncementsFail)]: (state: State): State => ({
      ...state,
      isLoading: false,
    }),

    [String(getAnnouncementFiltersSuccess)]: (
      state: State,
      action: Action<GetAnnouncementFilters$Response>,
    ): State => ({
      ...state,
      filters: action.payload,
    }),

    [String(createAnnouncementSuccess)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
    [String(createAnnouncementFail)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),

    [String(editAnnouncementSuccess)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
    [String(editAnnouncementFail)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),

    [String(deleteAnnouncementsSuccess)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
    [String(deleteAnnouncementsFail)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
  },
  new State(),
)

export { State as AnnouncementsState }
